import React from 'react'
import { Chip } from '@mui/material'
import { EMPTY_VALUE } from '../../constants.ts'
import isNil from 'lodash/isNil'

interface StatusCellProps {
  isActive?: boolean | null
}

export const StatusCell = ({ isActive }: StatusCellProps): React.ReactElement => {
  if (isNil(isActive)) {
    return <>{EMPTY_VALUE}</>
  }

  return (
    <Chip
      color={isActive ? 'success' : 'error'}
      label={isActive ? 'Активна' : 'Не активна'}
      variant="filled"
      size="small"
      sx={{
        borderRadius: 2,
      }}
    />
  )
}
